<template>
  <el-dialog
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :title="$t('customCluster.addInstanceDialog.title')"
    :visible.sync="dialogVisible"
    :z-index="1000"
    width="900px"
  >
    <div class="dialog-div">
      <div class="detailInfo_box">
        <el-row :gutter="20">
          <el-col :span="10">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.currentInstanceNum') }}</span>
              <span>{{ info.InstanceCount || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.region') }}</span>
              <span>{{ info.Region || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.zone') }}</span>
              <span>{{ info.Zone }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.relatedNetwork') }}</span>
              <span>{{ info.VpcId }}</span>
            </div>
          </el-col>
          <el-col :span="14">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.relatedSubnet') }}</span>
              <span>{{ info.SubnetId }} | {{ info.SubnetCidrBlock }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.securityGroup') }}</span>
              <span v-for="item in info.SecurityGroupIds" :key="item">
                <span>
                  {{ item }}
                </span>
              </span>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="base-margin__bottom-20">
        <span class="base-margin__right-20">{{ $t('customCluster.addInstanceDialog.addType') }}</span>
        <el-radio-group v-model="radio" @input="checkRadio">
          <el-radio :label="1">{{ $t('customCluster.addInstanceDialog.complete') }}</el-radio>
          <el-radio :label="2">{{ $t('customCluster.addInstanceDialog.increment') }}</el-radio>
        </el-radio-group>
      </div>
      <div class="base-margin__bottom-20">
        <div class=".base-flex__cross-center">
          <span class="base-margin__right-20 numberCls">{{ $t('multiCloudCluster.instanceTemplate') }}</span>
          <el-select
            class="base-width__320"
            v-model="launchTemplateId"
            @change="changeLaunchTemplate"
            :placeholder="$t('multiCloudCluster.selectInstanceTemplate')"
          >
            <el-option
              v-for="item in instanceTemplateList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div v-if="radio === 2" class="base-margin__bottom-20 base-flex">
        <span class="base-margin__right-20 start-ip">{{ $t('customCluster.addInstanceDialog.startIp') }}</span>
        <div class="start-ip__div">
          <div class="ip-part">
            <el-input v-model="startIp1" type="number"></el-input>
            <el-input v-model="startIp2" type="number"></el-input>
            <el-input v-model="startIp3" type="number"></el-input>
            <el-input v-model="startIp4" type="number"></el-input>
          </div>
        </div>
      </div>
      <div class="base-flex">
        <div class="base-margin__bottom-20 start-ip__div">
          <span class="base-margin__right-20 numberCls">{{ $t('customCluster.addInstanceDialog.quantity') }}</span>
          <el-input
            v-model="number"
            :placeholder="$t('customCluster.addInstanceDialog.pleaseEnter')"
            class="base-margin__right-10"
            type="number"
          >
            <el-button slot="prepend" icon="el-icon-minus" @click="number > 1 && number--"></el-button>
            <el-button slot="append" icon="el-icon-plus" @click="number++"></el-button>
          </el-input>
        </div>
        <div>
          <el-button class="canCreateIP" type="primary" @click="previewIp">
            {{ $t('customCluster.addInstanceDialog.previewIp') }}
          </el-button>
          <!--      预览ip-->
          <el-dialog
            :close-on-click-modal="false"
            :title="`${$t('customCluster.addInstanceDialog.previewIp')} ( ${previewList.length} )`"
            :visible.sync="previewDialogVisible"
            :z-index="1001"
            append-to-body
            width="500px"
          >
            <div class="previewDialog_main--div">
              <el-table
                ref="previewListTable"
                :data="previewList"
                :row-class-name="tableRowClassName"
                max-height="480"
                style="width: 100%"
              >
                <el-table-column
                  :label="$t('customCluster.addInstanceDialog.hostname')"
                  prop="hostname"
                  width="180"
                ></el-table-column>
                <el-table-column
                  :label="$t('customCluster.addInstanceDialog.ip')"
                  prop="ip"
                  width="180"
                ></el-table-column>
              </el-table>
            </div>
          </el-dialog>
        </div>
      </div>
      <div class="base-flex">
        <div class="numberCls base-margin__right-20"></div>
        <div class="base-margin__bottom-20 hintCls">{{ $t('customCluster.addInstanceDialog.resourceHint') }}</div>
      </div>
      <div v-if="instanceTemplateInstanceChargeType === 'PrePaid'">
        <div class="base-margin__bottom-20">
          <div class=".base-flex__cross-center">
            <span class="base-margin__right-20 numberCls">{{
              $t('customCluster.createCluster.form.renewalDuration')
            }}</span>
            <el-select
              v-model="period"
              class="base-width__320"
              :placeholder="$t('customCluster.createCluster.placeholder.selectRenewalDuration')"
            >
              <el-option
                v-for="item in timeOptions"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="base-margin__bottom-20">
          <div class=".base-flex__cross-center">
            <span class="base-margin__right-20 numberCls">{{
              $t('customCluster.createCluster.form.autoRenewal')
            }}</span>
            <el-checkbox v-model="autoRenew" false-label="false" true-label="true">
              <span class="base-color__light_grey">
                {{ $t('customCluster.createCluster.tips.autoRenewal') }}
              </span>
            </el-checkbox>
          </div>
        </div>
      </div>
      <div class="base-margin__bottom-20">
        <span class="base-margin__right-20">{{ $t('customCluster.addInstanceDialog.passwordType') }}</span>
        <el-radio-group v-model="passwordRadio" @input="checkPasswordRadio">
          <el-radio :disabled="info.imageType === 'PUBLIC_IMAGE'" :label="true">
            {{ $t('customCluster.addInstanceDialog.keepImageSetting') }}
          </el-radio>
          <el-radio :label="false">{{ $t('customCluster.addInstanceDialog.customPassword') }}</el-radio>
        </el-radio-group>
      </div>
      <div v-if="!isKeepImage">
        <div class="base-margin__bottom-20">
          <span class="base-margin__right-32" style="margin-right: 46px">
            {{ $t('customCluster.addInstanceDialog.password') }}
            <el-popover placement="top-start" trigger="hover" width="290">
              <div class="tips">
                <p>{{ $t('customCluster.addInstanceDialog.passwordRule1') }}</p>
                <p>{{ $t('customCluster.addInstanceDialog.passwordRule2') }}</p>
                <p>{{ $t('customCluster.addInstanceDialog.passwordRule3') }}</p>
                <p>{{ $t('customCluster.addInstanceDialog.passwordRule4') }}</p>
                <p class="base-margin__left-20">{{ $t('customCluster.addInstanceDialog.passwordRule5') }}</p>
                <p class="base-margin__left-20">{{ $t('customCluster.addInstanceDialog.passwordRule6') }}</p>
                <p class="base-margin__left-20">{{ $t('customCluster.addInstanceDialog.passwordRule7') }}</p>
                <p class="base-margin__left-20" v-text="'()`~!@#$%^&*-+=_|{}[]:;\'<>,.?/'"></p>
              </div>
              <el-icon slot="reference" class="el-icon-question">{{
                $t('customCluster.addInstanceDialog.hoverActivate')
              }}</el-icon>
            </el-popover>
          </span>
          <el-input
            v-model="password"
            :placeholder="$t('customCluster.addInstanceDialog.pleaseEnterPassword')"
            class="base-width__240"
            show-password
            type="password"
          ></el-input>
        </div>
        <div class="base-margin__bottom-20">
          <span class="base-margin__right-32"> {{ $t('customCluster.addInstanceDialog.confirmPassword') }} </span>
          <el-input
            v-model="nextPassword"
            :placeholder="$t('customCluster.addInstanceDialog.pleaseConfirmPassword')"
            class="base-width__240"
            show-password
            type="password"
          ></el-input>
        </div>
      </div>
    </div>
    <template #footer>
      <el-button :loading="examineInfoLoading" @click="runInstances('examine')">
        {{ $t('customCluster.addInstanceDialog.validateParams') }}
      </el-button>
      <el-button :disabled="subclusterDetailDisabled" type="primary" @click="runInstances('create')"
        >{{ $t('customCluster.addInstanceDialog.createInstance') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { postRequest } from '@/common/libs/request';
import { Message } from 'element-ui';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'addInstanceDialog',
  props: {
    showLoading: Function,
    describeMultiCloudPartitionInstances: Function,
  },

  data() {
    return {
      startIp1: '',
      startIp2: '',
      startIp3: '',
      startIp4: '',
      number: 1,
      password: '',
      nextPassword: '',
      dialogVisible: false,
      info: {},
      radio: 1,
      passwordRadio: true,
      isKeepImage: true,
      examineInfoLoading: false,
      subclusterDetailDisabled: false,
      previewDialogVisible: false,
      previewList: [],
      cloudType: '',
      instanceTemplateList: [],
      launchTemplateId: '',
      multiCloudClusterId: 0,
      instanceTemplateInstanceChargeType: '',
      period: 1,
      autoRenew: false,
      timeOptions: [
        // 购买时长选择
        { text: this.$t('customCluster.createCluster.duration.oneMonth'), value: 1 },
        { text: this.$t('customCluster.createCluster.duration.twoMonths'), value: 2 },
        { text: this.$t('customCluster.createCluster.duration.threeMonths'), value: 3 },
        { text: this.$t('customCluster.createCluster.duration.fourMonths'), value: 4 },
        { text: this.$t('customCluster.createCluster.duration.fiveMonths'), value: 5 },
        { text: this.$t('customCluster.createCluster.duration.sixMonths'), value: 6 },
        { text: this.$t('customCluster.createCluster.duration.sevenMonths'), value: 7 },
        { text: this.$t('customCluster.createCluster.duration.eightMonths'), value: 8 },
        { text: this.$t('customCluster.createCluster.duration.nineMonths'), value: 9 },
        // { text: this.$t('customCluster.createCluster.duration.tenMonths'), value: 10 },
        // { text: this.$t('customCluster.createCluster.duration.elevenMonths'), value: 11 },
        { text: this.$t('customCluster.createCluster.duration.oneYear'), value: 12 },
        { text: this.$t('customCluster.createCluster.duration.twoYears'), value: 24 },
        { text: this.$t('customCluster.createCluster.duration.threeYears'), value: 36 },
        { text: this.$t('customCluster.createCluster.duration.fourYears'), value: 48 },
        { text: this.$t('customCluster.createCluster.duration.fiveYears'), value: 60 },
      ],
    };
  },
  computed: {
    startIp() {
      return `${this.startIp1}.${this.startIp2}.${this.startIp3}.${this.startIp4}`;
    },
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    dialogVisible(val) {
      this.multiCloudClusterId = this.$route.query.id;
      if (val) {
        this.describeMultiCloudPartitionList();
        this.getInstanceTemplateList();
        this.password = '';
        this.nextPassword = '';
        this.number = 1;
        this.startIp1 = '';
        this.startIp2 = '';
        this.startIp3 = '';
        this.startIp4 = '';
        this.radio = 1;
        this.launchTemplateId = '';
        this.passwordRadio = true;
        this.isKeepImage = true;
        this.instanceTemplateInstanceChargeType = '';
      }
    },
    'app.currentProject'(val) {
      const currentProject = this.getCurrentProject();
      if (currentProject.id !== this.projectId) {
        this.projectId = val.id;
      }
    },
  },
  methods: {
    /**
     * 获取实例模版列表
     **/
    getInstanceTemplateList() {
      const params = {
        offset: 0,
        limit: 999,
        multiCloudPartitionId: Number(this.multiCloudClusterId),
      };
      postRequest('/api/eda/common/multicloud/getMultiCloudPartitionLaunchTemplate', params)
        .then((res) => {
          this.instanceTemplateList = res.launchTemplates || [];
        })
        .catch(() => {
          this.instanceTemplateList = [];
        });
    },

    /**
     * 获取分区信息
     */
    describeMultiCloudPartitionList() {
      const params = {
        filters: [{ name: 'id', values: [this.multiCloudClusterId] }],
        offset: 0,
        limit: 1000,
      };
      postRequest('/api/eda/common/multicloud/describeMultiCloudPartitionList', params).then((res) => {
        this.info = res.partitionList[0] || [];
        const list = this.info.SubnetCidrBlock.split('/')[0].split('.');
        this.startIp1 = list[0];
        this.startIp2 = list[1];
        this.startIp3 = list[2];
        this.startIp4 = list[3];
      });
    },

    tableRowClassName({ row }) {
      if (row.type === 'success-row') {
        return 'tableSelectBac';
      }
      return '';
    },

    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.editInstancesVisible = false;
    },

    // 预览可创建ip
    previewIp() {
      // 获取分区可用ip列表
      postRequest('/api/eda/common/multicloud/GetMultiCloudAvailableIPList', {
        multiCloudPartitionId: Number(this.multiCloudClusterId),
      }).then((res) => {
        this.previewList = res.relationList || [];
        this.previewDialogVisible = true;
        this.previewList = res.relationList.map((item) => ({ ...item, type: '' }));

        if (this.radio === 1) {
          // 补全模式逻辑
          this.previewList = this.previewList.map((item, index) =>
            index < this.number
              ? {
                  ...item,
                  type: 'success-row',
                }
              : item,
          );
        } else if (this.radio === 2 && this.startIp) {
          const cleanStartIp = this.startIp.trim();
          const startIndex = this.previewList.findIndex((item) => item.ip === cleanStartIp);

          if (startIndex >= 0) {
            const validNumber = Math.max(1, parseInt(this.number) || 1);
            const highlightCount = Math.min(validNumber, this.previewList.length - startIndex);

            this.previewList = this.previewList.map((item, index) =>
              index >= startIndex && index < startIndex + highlightCount ? { ...item, type: 'success-row' } : item,
            );
          } else {
            Message({
              type: 'warning',
              message: this.$t('customCluster.addInstanceDialog.startIpNotFound', { ip: cleanStartIp }),
            });
            this.previewList = this.previewList.map((item, index) =>
              index < this.number
                ? {
                    ...item,
                    type: 'success-row',
                  }
                : item,
            );
          }
        }
      });
    },

    /**
     * 新增实例
     * @type type
     * @param {string} type 1:创建 2：启动
     */
    runInstances(type) {
      const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      if (!ipRegex.test(this.startIp)) {
        return this.$message.warning(this.$t('customCluster.addInstanceDialog.invalidStartIp'));
      }

      // 判断密码是否符合规范
      if (this.password !== '' && !this.validPassword(this.password) && this.isKeepImage === false) {
        return false;
      }

      // 判断密码是否为空
      if (this.isKeepImage === false && this.password === '') {
        return Message.warning(this.$t('customCluster.addInstanceDialog.passwordRequired'));
      }

      // 判断密码是否为空
      if (this.launchTemplateId === '') {
        return Message.warning(this.$t('multiCloudCluster.selectInstanceTemplate'));
      }

      const data = {
        multiCloudPartitionId: Number(this.multiCloudClusterId),
        instanceCount: Number(this.number),
        startIp: this.startIp,
        password: this.password,
        imageLogin: this.isKeepImage,
        launchTemplateId: this.launchTemplateId,
        period: this.period,
        autoRenew: JSON.parse(this.autoRenew),
      };

      if (this.isKeepImage) {
        delete data.password;
      }

      if (type === 'create') {
        this.dialogVisible = false;
        this.$message.warning(this.$t('customCluster.addInstanceDialog.creating'));
        this.showLoading && this.showLoading(true);
        // 创建实例
        postRequest('/api/eda/common/multicloud/runInstances', {
          ...data,
          dryRun: false,
        })
          .then(() => {
            this.$message.success(this.$t('customCluster.addInstanceDialog.createSuccess'));
            this.showLoading && this.showLoading(false);
            // 获取分区实例列表  因为后台接口目前不支持直接请求 所以默认不请求 后续放开
            //   this.describeMultiCloudPartitionInstances();
          })
          .catch(() => {
            this.showLoading && this.showLoading(false);
          });
      } else {
        // 检查是否有可用实例
        this.examineInfoLoading = true;
        this.subclusterDetailDisabled = true;
        postRequest('/api/eda/common/multicloud/runInstances', {
          ...data,
          dryRun: true,
        })
          .then((res) => {
            if (res.errorMessage && res.errorMessage !== '') {
              Message.warning(res.errorMessage);
            } else {
              Message.success(this.$t('customCluster.addInstanceDialog.canCreate'));
            }
            this.examineInfoLoading = false;
            this.subclusterDetailDisabled = false;
          })
          .catch(() => {
            this.examineInfoLoading = false;
            this.subclusterDetailDisabled = false;
          });
      }
    },

    validPassword(pwd) {
      if (pwd.length < 12 || pwd.length > 30) {
        this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordLengthInvalid'));
        return false;
      }
      if (pwd.includes(' ')) {
        this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordContainsSpace'));
        return false;
      }
      if (this.password !== this.nextPassword) {
        Message.warning(this.$t('customCluster.addInstanceDialog.passwordMismatch'));
        return false;
      }

      if (pwd.startsWith('/')) {
        this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordStartsWithSlash'));
        return false;
      }

      // 只能含有数字,大小写字母及_@ 其必须包含 一个小写字母 或 一个大写字母 或 数字 或 ()`~!@#$%^&*-+=_|{}[]:;'<>,.?/
      let hasLower = 0;
      let hasUpper = 0;
      let hasDigit = 0;
      let hasSpecial = 0;
      for (let i = 0; i < pwd.length; i++) {
        const char = pwd[i];
        if (char >= 'a' && char <= 'z') {
          hasLower = 1;
        } else if (char >= 'A' && char <= 'Z') {
          hasUpper = 1;
        } else if (char >= '0' && char <= '9') {
          hasDigit = 1;
        } else if ("()`~!@#$%^&*-+=_|{}[]:;'<>,.?/".includes(char)) {
          hasSpecial = 1;
        } else {
          this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordInvalid'));
          return false;
        }
      }
      if (hasLower + hasUpper + hasDigit + hasSpecial < 3) {
        this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordComplexity'));
        return false;
      }
      return true;
    },
    checkRadio(val) {
      if (val === 1) {
        const list = this.info.subnetCidr.split('/')[0].split('.');
        this.startIp1 = list[0];
        this.startIp2 = list[1];
        this.startIp3 = list[2];
        this.startIp4 = list[3];
      }
    },

    checkPasswordRadio(val) {
      if (val === true) {
        this.isKeepImage = true;
        this.password = '';
        this.nextPassword = '';
      }
      if (val === false) {
        this.password = '';
        this.nextPassword = '';
        this.isKeepImage = false;
      }
    },

    // 选择实例模板  instanceChargeType
    changeLaunchTemplate(val) {
      this.instanceTemplateInstanceChargeType = this.instanceTemplateList.find(
        (item) => item.id === val,
      ).instanceChargeType;
      if (this.instanceTemplateInstanceChargeType === 'PrePaid') {
        this.period = 1;
        this.autoRenew = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-div > div > span:first-child {
  color: #999;
  width: 74px;
  display: inline-block;
}

.detailInfo_box {
  background: #eee;
  padding: 10px;
  margin-bottom: 20px;
  line-height: 1.8;
  font-size: 12px;
}

.infoTitle {
  width: 70px;
  display: inline-block;
  text-align: left;
}

.numberCls {
  color: #999;
  width: 74px;
  display: inline-block;
}

.hintCls {
  margin-top: -16px;
  color: #999;
  font-size: 10px;
}

.previewDialog_main--div {
  max-height: 500px;
  overflow: auto;
}

.dialog-div {
  div > .el-button {
    padding: 12px;
  }

  .el-input {
    width: 200px;
  }
}

.start-ip__div {
  display: flex;
  align-items: center;

  ::v-deep .el-input__inner {
    text-align: center;
    -moz-appearance: textfield;
  }

  ::v-deep .el-input__inner::-webkit-inner-spin-button,
  ::v-deep .el-input__inner::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }
}

.ip-part {
  display: inline-block;

  .el-input {
    width: 40px;
    margin-right: 10px;

    ::v-deep .el-input__inner {
      padding: 0;
    }
  }
}

.add-btn {
  padding: 0 !important;
  height: 32px;
  margin-left: 10px;
}

.start-ip {
  height: 32px;
  line-height: 32px;
}

.tips {
  p {
    margin-bottom: 10px;
  }
}

.examineMachine {
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.canCreateIP {
  height: 30px;
  line-height: 6px;
}

.formItem__select-short {
  width: 170px;
}

.formItem__select-long {
  width: 500px;
}
</style>
<style>
.tableSelectBac {
  background: #f0f9eb !important;
}
</style>
